import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchive = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 21,
	viewBox: "0 0 21 21",
	width: 21,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: .6,
		transform: "translate(2 3)",
		children: [/* @__PURE__ */ _jsx("path", { d: "m1.5 4.5h14v7.9976807c0 1.1045695-.8954305 2-2 2h-10c-1.1045695 0-2-.8954305-2-2zm0-3.9777832h14c.5522847 0 1 .44771525 1 1v1.9777832c0 .55228475-.4477153 1-1 1h-14c-.55228475 0-1-.44771525-1-1v-1.9777832c0-.55228475.44771525-1 1-1z" }), /* @__PURE__ */ _jsx("path", { d: "m6.5 7.5h4" })]
	})
});
export default SvgArchive;
